package org.solyton.solawi.bid.application.ui.page.login.action

import org.evoleq.compose.Markup
import org.evoleq.optics.storage.Action
import org.solyton.solawi.bid.application.data.Application
import org.solyton.solawi.bid.application.data.userData
import org.solyton.solawi.bid.application.storage.event.ACCESS_TOKEN
import org.solyton.solawi.bid.application.storage.event.REFRESH_TOKEN
import org.solyton.solawi.bid.module.authentication.data.api.IsLoggedIn
import org.solyton.solawi.bid.module.authentication.data.api.LoggedInAs
import org.solyton.solawi.bid.module.localstorage.api.write
import org.solyton.solawi.bid.module.user.data.user.accessToken
import org.solyton.solawi.bid.module.user.data.user.refreshToken
import org.solyton.solawi.bid.module.user.data.user.username

const val IS_LOGGED_IN = "IsLoggedIn"

@Markup
val isLoggedInAction: Action<Application, IsLoggedIn, LoggedInAs> =
    Action(
        IS_LOGGED_IN,
        reader = { app: Application -> IsLoggedIn(app.userData.refreshToken) },
        endPoint = IsLoggedIn::class,
        writer = { loggedInAs: LoggedInAs -> {
            app -> if(loggedInAs.username == "" ){
            val env = app.environment.type
            val accessTokenKey = "${env.lowercase()}_$ACCESS_TOKEN"
            val refreshTokenKey = "${env.lowercase()}_$REFRESH_TOKEN"
                write(accessTokenKey, "")
                write(refreshTokenKey, "")
                app.userData {
                    accessToken { "" }.
                    refreshToken { "" }
                }
            } else {
                app.userData{
                    username { loggedInAs.username }.
                    refreshToken { loggedInAs.refreshToken }.
                    accessToken { loggedInAs.accessToken }
                }
            }
        }}
    )

